import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <Container>
        <Row>
          <Col md={4}>
            <ul className="footer-links">
            <li><a href="/hakkinda">Hakkında</a></li>
              <li><a href="/maddeler">Maddeler</a></li>
              <li><a href="/yazarlar">Yazarlar</a></li>
              <li><a href="/gelismis-arama">Gelişmiş Arama</a></li>
              <li><a href="/harita">Harita</a></li>
              <li><a href="/iletisim">İletişim</a></li>
            </ul>
          </Col>
          <Col md={4}>
            <ul className="footer-links">
              <li><a href="/hakkinda">Türk Sanatında Sanatçılar Ansiklopedisi Hakkında</a></li>
              <li><a href="/sorumluluk-reddi">Sorumluluk Reddi</a></li>
              <li><a href="/gizlilik-politikasi">Gizlilik Politikası</a></li>
            </ul>
          </Col>
          <Col md={4}>
            <div className="footer-contact">
              <h3>İletişim</h3>
              <p><span>Adres:</span>Üniversiteler Mah. Toplum Cad. No.5 Çankaya/ANKARA</p>
              <p><span>Telefon:</span> 284 34 18</p>
              <p><span>E-posta:</span> turksaprojesi@akmb.gov.tr</p>
            </div>
          </Col>
        </Row>
        <div className="footer-bottom">
          <p>&copy; 2025 Atatürk Kültür Merkezi Başkanlığı. Tüm hakları saklıdır.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer; 